import React from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty, size } from "lodash";

import CollectionHeaderPartner from "../collection-header-partner/CollectionHeaderPartner";
import UploadFiles from "../upload-files/UploadFiles";
import {
  SECTION_ITINERARY_COMPONENTS,
  BUCKET_PATH,
} from "../../../utils/constant";
import { setUploadFiles } from "../../../redux/upload-files/uploadFiles.action";

const UploadItinerary = (props) => {
  const itineraryState = useSelector((state) => state.itineraryEm);
  const uploadFilesState = useSelector((state) => state.uploadFiles);

  const dispatch = useDispatch();

  const params = useParams();

  const handleDrop = (acceptedFiles) => {
    let lastId = null;
    if (!isEmpty(uploadFilesState.fileProgress)) {
      const ids = Object.keys(uploadFilesState.fileProgress);
      lastId = Math.max(...ids);
    } else if (!isEmpty(itineraryState.response.data)) {
      const ids = itineraryState.response.data.map((item) => item.sequence);
      lastId = Math.max(...ids);
    }

    const payload = [];
    for (let i = 0; i < size(acceptedFiles); i++) {
      const file = acceptedFiles[i];
      payload.push({
        file: file,
        sequence: lastId ? lastId + i + 1 : i + 1,
        payload: [
          {
            bucket_path: `${BUCKET_PATH.collection}/${params.collectionId}/${BUCKET_PATH.itinerary}/${file.name}`,
            image_name: file.name,
          },
        ],
      });
    }

    dispatch(setUploadFiles(payload));
    props.setCurrentMainComponent((prevState) => {
      return {
        currComponent: SECTION_ITINERARY_COMPONENTS.uploading_itinerary,
        prevComponent: prevState.currComponent,
      };
    });
  };

  return (
    <main
      style={{ maxWidth: "850px", marginLeft: "auto", marginRight: "auto" }}
    >
      <CollectionHeaderPartner
        title="Add Itinerary"
        cancelBtn={true}
        handleCancelBtnClick={props.onCancelClick}
      />
      <div style={{ marginTop: "20%" }}>
        <UploadFiles
          heading="Upload itinerary here"
          subHeading="JPEG files upto 50MB each"
          buttonLabel="Choose itinerary to upload"
          handleDropEvent={handleDrop}
        />
      </div>
    </main>
  );
};

export default UploadItinerary;
